export enum HepsiburadaOrderStatus {
  CANCELLED = 'cancelled',
  OPEN = 'Open',
}

export const hepsiburadaOrderStatusNameMap: Record<
  HepsiburadaOrderStatus,
  string
> = {
  [HepsiburadaOrderStatus.CANCELLED]: 'İptal Edildi',
  [HepsiburadaOrderStatus.OPEN]: 'Sipariş Oluşturuldu',
};
